/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Minimal candidate header consumed by Inbox + spec-03 side panel.
 *
 * Full profile lives behind a "Full Profile" link. We embed the
 * minimal header here so the thread/chat detail endpoints can
 * render the right rail without a follow-up fetch.
 */
export interface SidePanelSummary {
  job_candidate_id: string;
  profile_id?: string | null;
  /** @maxLength 200 */
  name: string;
  headline?: string | null;
  avatar_url?: string | null;
  step_label?: string | null;
  enrollment_status?: string | null;
}
